@if (paging.count > paging.pageSize) {
  <ngb-pagination
    [collectionSize]="paging.count"
    [pageSize]="paging.pageSize"
    [(page)]="paging.currentPage"
    [maxSize]="20"
    (pageChange)="onPageChange($event)"
    [directionLinks]="true"
    />
}
